import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import './index.css';
import theme from './theme';
import { registerAppServiceWorker } from './registerAppServiceWorker';
import reportWebVitals from './reportWebVitals';

const appVariant = process.env.REACT_APP_APP_VARIANT || 'parent';
const App = React.lazy(() => (
  appVariant === 'kids'
    ? import('./apps/KidsApp')
    : import('./apps/ParentApp')
));

function AppLoading() {
  const appName = appVariant === 'kids' ? 'TimeBank Kids' : 'TimeBank';
  const iconPath = process.env.REACT_APP_APP_ICON || '/parent-icon-192.png';

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        alignItems: 'center',
        background: '#fffdf9',
        color: '#0d2942',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        gap: '16px',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <img
        src={iconPath}
        alt=""
        width="72"
        height="72"
        style={{ borderRadius: '18px' }}
      />
      <div style={{ fontSize: '22px', fontWeight: 800, letterSpacing: '-0.03em' }}>
        {appName}
      </div>
      <div style={{ color: '#53697a', fontSize: '14px' }}>Opening your app…</div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <React.Suspense fallback={<AppLoading />}>
        <App />
      </React.Suspense>
    </ChakraProvider>
  </React.StrictMode>
);

registerAppServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
